import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于无极电影网，你想知道的都在这里
          </p>
        </div>

        <div className="max-w-[800px] mx-auto grid grid-cols-1 gap-4">
          {faqData.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500/20 text-primary-500 text-sm flex-shrink-0 mt-0.5">
                    Q
                  </span>
                  {item.question}
                </h3>
                <p className="mt-3 pl-9 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}